import { RangeDateInput, TextInput } from '@core/components/Inputs';
import { SimpleTableBase } from '@core/components/Table';
import { DataBR } from '@format';
import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import { getCurrency } from 'app/utils/monetarioUtil';
import { useFormikContext } from 'formik';
import React, { useContext, useEffect } from 'react';
import { ResgatarContaReceberContratoContext } from '../resgatarContaReceberContratoContext';

const onlyNumberRegex = /^\d*$/;

const resgatarContaReceberContratoStyles = makeStyles(() => ({
  buttonSave: {
    background: '#43a047',
    border: '1px solid #43a047',
    color: '#fff',
    width: 90,
    height: 36,
    borderRadius: 5,
    textTransform: 'capitalize',
    transition: '0.4s',
    '&:hover': {
      color: '#43a047',
    },
  },
}));

const ResgatarContaReceberContratoTable = ({ fetchReceitas }) => {
  const [contasReceber] = useContext(ResgatarContaReceberContratoContext).contasReceber;
  const [selecao, setSelecao] = useContext(ResgatarContaReceberContratoContext).selecao;
  const [tipoSelecao, setTipoSelecao] = useContext(ResgatarContaReceberContratoContext).tipoSelecao;
  const [totalElements] = useContext(ResgatarContaReceberContratoContext).totalElements;
  const [loading] = useContext(ResgatarContaReceberContratoContext).loading;
  const [, setPage] = useContext(ResgatarContaReceberContratoContext).page;
  const [size, setSize] = useContext(ResgatarContaReceberContratoContext).size;
  const [sort, setSort] = useContext(ResgatarContaReceberContratoContext).sort;

  const formik = useFormikContext();
  const { errors, touched } = formik;

  const styles = resgatarContaReceberContratoStyles();

  const columns = [
    {
      name: 'contrato.id',
      title: 'Identificador',
      getCellValue: (data) => data.identificador,
      sortingEnabled: true,
    },
    {
      name: 'dataVencimento',
      title: 'Vencimento',
      getCellValue: (data) => {
        return <div>{DataBR(data.dataVencimento)}</div>;
      },
      hideTooltip: true,
      sortingEnabled: true,
    },
    {
      name: 'cliente',
      title: 'Cliente',
      getCellValue: (data) => data.cliente,
      align: 'left',
    },
    {
      name: 'valor',
      title: 'Valor (R$)',
      align: 'right',
      getCellValue: (data) => getCurrency(data.valor),
    },
  ];

  useEffect(() => {
    fetchReceitas({
      page: 0,
      size,
      sort,
      dataVencimentoInicio: formik.values?.dataVencimentoInicio?.format('YYYY-MM-DD'),
      dataVencimentoFim: formik.values?.dataVencimentoFim?.format('YYYY-MM-DD'),
    });
    // Memoização intencional: as funções/props são recriadas a cada render e incluí-las
    // anularia o memo; o estado que elas leem já está nas dependências.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFetchData = (params) => {
    fetchReceitas({
      page: params.page,
      size: params.size,
      sort: params.sort,
      identificador: formik.values?.identificador,
      dataVencimentoInicio: formik.values?.dataVencimentoInicio?.format('YYYY-MM-DD'),
      dataVencimentoFim: formik.values?.dataVencimentoFim?.format('YYYY-MM-DD'),
    });
  };

  return (
    <Grid container style={{ padding: 16 }} spacing={2}>
      <Grid item xs={5} sm={5} md={5} lg={5}>
        <RangeDateInput
          id="dataVencimento"
          name="dataVencimento"
          value={[formik.values?.dataVencimentoInicio, formik.values?.dataVencimentoFim]}
          label="Período do vencimento "
          onChange={(inicio, fim) => {
            formik.setFieldValue('dataVencimentoInicio', inicio);
            formik.setFieldValue('dataVencimentoFim', fim);
          }}
          format="DD/MM/YYYY"
          openTo="date"
          views={['date', 'month', 'year']}
          touched={touched?.dataVencimentoInicio || touched?.dataVencimentoFim}
          error={errors.dataVencimentoInicio || errors.dataVencimentoFim}
          helperText={errors.dataVencimentoInicio || errors.dataVencimentoFim}
        />
      </Grid>
      <Grid item xs={5} sm={5} md={5} lg={5}>
        <TextInput
          id="identificador"
          name="identificador"
          label="Identificador"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.identificador}
          maxLength={3}
          fullWidth
          variant="outlined"
          pattern={onlyNumberRegex}
        />
      </Grid>
      <Grid item xs={2} sm={2} md={2} lg={2} alignContent="center" justify="center">
        <Button
          className={styles.buttonSave}
          onClick={() => {
            if (Object.keys(errors).length === 0) {
              fetchReceitas({
                page: 0,
                size,
                sort,
                identificador: formik.values?.identificador,
                dataVencimentoInicio: formik.values?.dataVencimentoInicio?.format('YYYY-MM-DD'),
                dataVencimentoFim: formik.values?.dataVencimentoFim?.format('YYYY-MM-DD'),
              });
            }
          }}
        >
          <Typography>Buscar</Typography>
        </Button>
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <SimpleTableBase
          pageType="async"
          defaultSorting={[{ columnName: 'dataVencimento', direction: 'DESC' }]}
          columns={columns}
          rows={contasReceber?.map((contaReceber) => ({
            ...contaReceber,
            key: contaReceber?.contratoContaReceberId,
          }))}
          loading={loading}
          totalCount={totalElements}
          searchBy=""
          fetchData={onFetchData}
          onSelectionChange={setSelecao}
          onCurrentPageChange={(params) => {
            setPage(params);
          }}
          onPageSizeChange={(params) => {
            setSize(params);
          }}
          onSortingChange={(params) => {
            setSort(params);
          }}
          selection={selecao}
          selectionType={tipoSelecao}
          onSelectionTypeChange={setTipoSelecao}
        />
      </Grid>
    </Grid>
  );
};

export default ResgatarContaReceberContratoTable;
